// extracted by mini-css-extract-plugin
export default {"root":"IconFileUpload_root__8dtMV"};